import { Formik } from "formik";
import * as Yup from "yup";
import { MdOutlineEmail } from "react-icons/md";
import { registerAction } from "../../redux/auth/saga";
import { useDispatch, useSelector } from "react-redux";
import { getLocalization } from "../../redux/localization";
import { toast } from "react-toastify";
import { useState } from "react";
import Loader from "../Loader";
import { clientAppUrl } from "../../redux/base/types/url";
import { gtag_report_conversion } from "../../helpers/gtag";

const RegisterFree = () => {
  const t = useSelector(getLocalization);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={{
        Email: "",
      }}
      validationSchema={Yup.object().shape({
        Email: Yup.string()
          .required(t.getString("This field is required"))
          .email(t.getString("Email is not valid")),
      })}
      onSubmit={(values) => {
        setLoader(true);
        dispatch(
          registerAction({
            payload: {
              onSuccess: (message, payload) => {
                setLoader(false);
                toast.success(message, {
                  theme: "colored",
                });
                gtag_report_conversion(clientAppUrl + "/login/" + payload);

                setTimeout(() => {
                  window.open(clientAppUrl + "/login/" + payload, "_blank");
                }, 3000);
              },
              onError: (message, errordetails) => {
                var msg =
                  errordetails.Errors && errordetails.Errors[0].Description
                    ? errordetails.Errors[0].Description
                    : message;
                toast.error(msg, {
                  theme: "colored",
                });
                return setLoader(false);
              },
            },
            body: values,
          })
        );
      }}
    >
      {({ setFieldValue, errors, values, handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className="w-100 d-flex justify-content-center align-items-center mt-2">
            <div className="homepageEmailInputContainer">
              {loader && <Loader />}
              {errors.Email ? (
                <div data-tooltip={errors.Email}>
                  <MdOutlineEmail size={28} color={"red"} />
                </div>
              ) : (
                <MdOutlineEmail size={44} />
              )}
              <input
                placeholder={t.getString("Your Email Address")}
                type={"email"}
                style={{ width: "calc(100% - 10px)" }}
                value={values.Email}
                onChange={(e: any) => setFieldValue("Email", e.target.value)}
              />
              <button
                type="submit"
                className="primaryButton"
                style={{
                  width: "200px",
                }}
              >
                {t.getString("Register Free")}
              </button>
            </div>
          </div>

          {/* ➕ Alt bilgi metni */}
          <div className="text-center mt-2">
            <small style={{ color: "#6c757d" }}>
              {t.getString("No credit card required")}
            </small>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default RegisterFree;
